import { call, take, takeLatest } from "redux-saga/effects";
import {
  CUSTOMER_DETAIL,
  CUSTOMER_ENABLE_DISABLE,
  CUSTOMER_LIST,
  CUSTOMER_SEND_MAIL,
  CUSTOMER_VERSION_DETAIL,
  CUSTOMER_VERSION_LIST,
  FETCH_CUSTOMER_HEADQUARTER,
  SUBSCRIBER_REQUEST_DETAIL,
  SUBSCRIBER_REQUEST_LIST,
  CUSTOMER_DIVISION_LIST,
  CUSTOMER_DIVISION_FEILD_FORCE_LIST,
  CUSTOMER_ADD_DIVISION,
  CUSTOMER_DELETE_DIVISION,
  CUSTOMER_PRODUCT_OFFER_REQUEST_LIST,
  CUSTOMER_PRODUCT_OFFER_REQUEST_VIEW,
  CUSTOMER_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
  CUSTOMER_PRODUCT_OFFER_LIST,
  CUSTOMER_PRODUCT_OFFER_REMOVE,
  CUSTOMER_PRODUCT_OFFER_PRODUCTS_LIST,
  CUSTOMER_PRODUCT_OFFER_ADD,
  CUSTOMER_PRODUCT_OFFER_EDIT,
  PHARMACY_PRODUCT_OFFER_REQUEST_LIST,
  PHARMACY_PRODUCT_OFFER_REQUEST_VIEW,
  PRODUCT_OFFER_REQUEST_APPROVE_ALL,
  PRODUCT_OFFER_REQUEST_REJECT_ALL,
  PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_ALL,
  PHARMACY_PRODUCT_OFFER_REQUEST_REJECT_ALL,
  PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
  PHARMACY_PRODUCT_OFFER_LIST,
  PHARMACY_PRODUCT_OFFER_EDIT,
  CUSTOMER_PHARMACY_LIST,
  CUSTOMER_PHARMACY_DETAIL,
  SUBSCRIBER_REQUEST_PHARMACY_LIST,
  SUBSCRIBER_REQUEST_PHARMACY_DETAIL,
  UPDATE_PHARMACY_TYPE,
  UPDATE_DOCTOR_TYPE,
  DOCTOR_ONBOARD_PRODUCT_LIST,
  PHARMACY_ONBOARD_PRODUCT_LIST,
  CUSTOMER_ADD_PRODUCT_LIST,
  CUSTOMER_ADD_PRODUCT_OFFER_LIST,
  ADD_CUSTOMER_PRODUCT,
  ADD_PHARMACY_PRODUCT,
  CUSTOMER_SUBSCRIBER_REQUEST_LIST,
  CUSTOMER_SUBSCRIBER_REQUEST_DETAIL,
} from "../actions/types";
import * as customerApis from "../apis/customerApis";

export function* customerListWorker(action) {
  try {
    const res = yield call(customerApis.CustomerList, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerDetailWorker(action) {
  try {
    const res = yield call(customerApis.CustomerDetail, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerPharmacyListWorker(action) {
  try {
    const res = yield call(customerApis.CustomerPharmacyList, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerPharmacyDetailWorker(action) {
  try {
    const res = yield call(customerApis.CustomerPharmacyDetail, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* subscriberRequestListWorker(action) {
  try {
    const res = yield call(customerApis.subcriberRequestList, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* subcriberRequestDetailWorker(action) {
  try {
    const res = yield call(customerApis.subcriberRequestDetail, {
      doctor_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* subscriberRequestPharmacyListWorker(action) {
  try {
    const res = yield call(
      customerApis.subcriberRequestPharmacyList,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* subcriberRequestPharmacyDetailWorker(action) {
  try {
    const res = yield call(customerApis.subcriberRequestPharmacyDetail, {
      pharmacy_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerSubscriberRequestListWorker(action) {
  try {
    const res = yield call(
      customerApis.customerSubcriberRequestList,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerSubcriberRequestDetailWorker(action) {
  try {
    const res = yield call(customerApis.customerSubcriberRequestDetail, {
      vendor_subscribe_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerVersionHistoryListWorker(action) {
  try {
    const res = yield call(customerApis.customerVersionList, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerVersionDetailWorker(action) {
  try {
    const res = yield call(customerApis.customerVersionDetail, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerApproveRejectWorker(action) {
  try {
    const res = yield call(customerApis.approveRejectCustomer, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* fetchHeadQuarterListWorker(action) {
  try {
    const res = yield call(customerApis.fetchHeadQuarterCustomerApi, {
      state_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* CustomerSendMailWorker(action) {
  try {
    const res = yield call(customerApis.customerSendMailApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* CustomerDivisionListWorker(action) {
  console.log(action);
  try {
    const res = yield call(customerApis.fetchDivisionsApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* CustomerDivisionFFListWorker(action) {
  console.log(action);
  try {
    const res = yield call(
      customerApis.fetchHQDivisionalFeildForceUsers,
      action.data
    );
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: `${ele.name} - ${ele.employee_id}`,
      }));

      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* CustomerAddDivisionWorker(action) {
  console.log(action);
  try {
    const res = yield call(customerApis.addDivisionToCustomer, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* CustomerDeleteDivisionWorker(action) {
  console.log(action);
  try {
    const res = yield call(
      customerApis.deleteDivisionFromCustomer,
      action.data
    );
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferRequestListWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyProductOfferRequestListWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyroductOfferRequestListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferRequestViewWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestViewApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyProductOfferRequestViewWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyProductOfferRequestViewApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferRequestApproveAllWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestApproveAllApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferRequestRejectAllWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestRejectAllApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyProductOfferRequestApproveAllWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyProductOfferRequestApproveAllApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyProductOfferRequestRejectAllWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyProductOfferRequestRejectAllApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferRequestApproveRejectWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestApproveRejectApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyroductOfferRequestApproveRejectWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyProductOfferRequestApproveRejectApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOffersListWorker(action) {
  try {
    const res = yield call(customerApis.productOffersListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyProductOffersListWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyProductOffersListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferRemoveWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestRemoveApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferAddWorker(action) {
  try {
    const res = yield call(customerApis.productOfferRequestAddApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferEditWorker(action) {
  try {
    const res = yield call(
      customerApis.productOfferRequestEditApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyProductOfferEditWorker(action) {
  try {
    const res = yield call(
      customerApis.pharmacyProductOfferRequestEditApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productOfferDivisionProductsWorker(action) {
  try {
    const res = yield call(
      customerApis.productOffersDivsionProductsListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* updateDoctorTypeWorker(action) {
  try {
    const res = yield call(customerApis.updateDoctorType, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* updatePharmacyTypeWorker(action) {
  try {
    const res = yield call(customerApis.updatePharmacyType, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* onboardDoctorProductOffersListWorker(action) {
  try {
    const res = yield call(
      customerApis.onboardDoctorProductOffersListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* onboardPharmacyProductOffersListWorker(action) {
  try {
    const res = yield call(
      customerApis.onboardPharmacyProductOffersListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerAddProductListWorker(action) {
  try {
    const res = yield call(customerApis.customerAddProductListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerAddProductOffersListWorker(action) {
  try {
    const res = yield call(
      customerApis.customerAddProductOfferListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* addCustomerProductWorker(action) {
  try {
    const res = yield call(customerApis.addCustomerProduct, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* addPharmacyProductWorker(action) {
  try {
    const res = yield call(customerApis.addPharmacyProduct, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* customerListWatcher() {
  yield takeLatest(CUSTOMER_LIST, customerListWorker);
}

export function* customerDetailWatcher() {
  yield takeLatest(CUSTOMER_DETAIL, customerDetailWorker);
}

export function* subscriberRequestListWatcher() {
  yield takeLatest(SUBSCRIBER_REQUEST_LIST, subscriberRequestListWorker);
}

export function* subcriberRequestDetailWatcher() {
  yield takeLatest(SUBSCRIBER_REQUEST_DETAIL, subcriberRequestDetailWorker);
}

export function* customerVersionHistoryListWatcher() {
  yield takeLatest(CUSTOMER_VERSION_LIST, customerVersionHistoryListWorker);
}
export function* customerVersionDetailWatcher() {
  yield takeLatest(CUSTOMER_VERSION_DETAIL, customerVersionDetailWorker);
}

export function* customerApproveRejectWatcher() {
  yield takeLatest(CUSTOMER_ENABLE_DISABLE, customerApproveRejectWorker);
}

export function* fetchHeadQuarterListWatcher() {
  yield takeLatest(FETCH_CUSTOMER_HEADQUARTER, fetchHeadQuarterListWorker);
}
export function* CustomerSendMailWatcher() {
  yield takeLatest(CUSTOMER_SEND_MAIL, CustomerSendMailWorker);
}
export function* CustomerDivisionListWatcher() {
  yield takeLatest(CUSTOMER_DIVISION_LIST, CustomerDivisionListWorker);
}

export function* CustomerDivisionFeildForceListWatcher() {
  yield takeLatest(
    CUSTOMER_DIVISION_FEILD_FORCE_LIST,
    CustomerDivisionFFListWorker
  );
}

export function* CustomerAddDivisionWatcher() {
  yield takeLatest(CUSTOMER_ADD_DIVISION, CustomerAddDivisionWorker);
}
export function* CustomerDeleteDivisionWatcher() {
  yield takeLatest(CUSTOMER_DELETE_DIVISION, CustomerDeleteDivisionWorker);
}

export function* productOfferRequestListWatcher() {
  yield takeLatest(
    CUSTOMER_PRODUCT_OFFER_REQUEST_LIST,
    productOfferRequestListWorker
  );
}

export function* pharmacyProductOfferRequestListWorkerWatcher() {
  yield takeLatest(
    PHARMACY_PRODUCT_OFFER_REQUEST_LIST,
    pharmacyProductOfferRequestListWorker
  );
}

export function* productOfferRequestViewWatcher() {
  yield takeLatest(
    CUSTOMER_PRODUCT_OFFER_REQUEST_VIEW,
    productOfferRequestViewWorker
  );
}

export function* pharmacyProductOfferRequestViewWatcher() {
  yield takeLatest(
    PHARMACY_PRODUCT_OFFER_REQUEST_VIEW,
    pharmacyProductOfferRequestViewWorker
  );
}
export function* productOfferRequestApproveAllWatcher() {
  yield takeLatest(
    PRODUCT_OFFER_REQUEST_APPROVE_ALL,
    productOfferRequestApproveAllWorker
  );
}

export function* productOfferRequestRejectAlWatcher() {
  yield takeLatest(
    PRODUCT_OFFER_REQUEST_REJECT_ALL,
    productOfferRequestRejectAllWorker
  );
}

export function* pharmacyProductOfferRequestApproveAllWatcher() {
  yield takeLatest(
    PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_ALL,
    pharmacyProductOfferRequestApproveAllWorker
  );
}

export function* pharmacyProductOfferRequestRejectAlWatcher() {
  yield takeLatest(
    PHARMACY_PRODUCT_OFFER_REQUEST_REJECT_ALL,
    pharmacyProductOfferRequestRejectAllWorker
  );
}

export function* productOfferRequestApproveRejectWatcher() {
  yield takeLatest(
    CUSTOMER_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
    productOfferRequestApproveRejectWorker
  );
}

export function* pharmacyroductOfferRequestApproveRejectWatcher() {
  yield takeLatest(
    PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_REJECT,
    pharmacyroductOfferRequestApproveRejectWorker
  );
}

export function* productOffersListWatcher() {
  yield takeLatest(CUSTOMER_PRODUCT_OFFER_LIST, productOffersListWorker);
}
export function* pharmacyProductOffersListWatcher() {
  yield takeLatest(
    PHARMACY_PRODUCT_OFFER_LIST,
    pharmacyProductOffersListWorker
  );
}

export function* productOfferRemoveWatcher() {
  yield takeLatest(CUSTOMER_PRODUCT_OFFER_REMOVE, productOfferRemoveWorker);
}

export function* productOfferAddWatcher() {
  yield takeLatest(CUSTOMER_PRODUCT_OFFER_ADD, productOfferAddWorker);
}

export function* productOfferEditWatcher() {
  yield takeLatest(CUSTOMER_PRODUCT_OFFER_EDIT, productOfferEditWorker);
}
export function* pharmacyProductOfferEditWatcher() {
  yield takeLatest(PHARMACY_PRODUCT_OFFER_EDIT, pharmacyProductOfferEditWorker);
}

export function* productOfferDivisionProductsWatcher() {
  yield takeLatest(
    CUSTOMER_PRODUCT_OFFER_PRODUCTS_LIST,
    productOfferDivisionProductsWorker
  );
}
export function* customerPharmacyListWatcher() {
  yield takeLatest(CUSTOMER_PHARMACY_LIST, customerPharmacyListWorker);
}

export function* customerPharmacyDetailWatcher() {
  yield takeLatest(CUSTOMER_PHARMACY_DETAIL, customerPharmacyDetailWorker);
}

export function* subscriberRequestPharmacyListWatcher() {
  yield takeLatest(
    SUBSCRIBER_REQUEST_PHARMACY_LIST,
    subscriberRequestPharmacyListWorker
  );
}

export function* subcriberRequestPharmacyDetaillWatcher() {
  yield takeLatest(
    SUBSCRIBER_REQUEST_PHARMACY_DETAIL,
    subcriberRequestPharmacyDetailWorker
  );
}

export function* updateDoctorTypeWatcher() {
  yield takeLatest(UPDATE_DOCTOR_TYPE, updateDoctorTypeWorker);
}

export function* updatePharmacyTypeWatcher() {
  yield takeLatest(UPDATE_PHARMACY_TYPE, updatePharmacyTypeWorker);
}

export function* onboardDoctorProductOffersListWatcher() {
  yield takeLatest(
    DOCTOR_ONBOARD_PRODUCT_LIST,
    onboardDoctorProductOffersListWorker
  );
}

export function* onboardPharmacyProductOffersListWatcher() {
  yield takeLatest(
    PHARMACY_ONBOARD_PRODUCT_LIST,
    onboardPharmacyProductOffersListWorker
  );
}
export function* customerAddProductListWatcher() {
  yield takeLatest(CUSTOMER_ADD_PRODUCT_LIST, customerAddProductListWorker);
}
export function* customerAddProductOffersListWatcher() {
  yield takeLatest(
    CUSTOMER_ADD_PRODUCT_OFFER_LIST,
    customerAddProductOffersListWorker
  );
}
export function* addCustomerProductWatcher() {
  yield takeLatest(ADD_CUSTOMER_PRODUCT, addCustomerProductWorker);
}
export function* addPharmacyProductWatcher() {
  yield takeLatest(ADD_PHARMACY_PRODUCT, addPharmacyProductWorker);
}
export function* customerSubscriberRequestListWatcher() {
  yield takeLatest(
    CUSTOMER_SUBSCRIBER_REQUEST_LIST,
    customerSubscriberRequestListWorker
  );
}
export function* customerSubcriberRequestDetailWatcher() {
  yield takeLatest(
    CUSTOMER_SUBSCRIBER_REQUEST_DETAIL,
    customerSubcriberRequestDetailWorker
  );
}
